import i18n, {type InitOptions} from 'i18next';
import en from '../locales/en';
import i18nFormat from '../lib/i18nFormat';
import {legacyIsProduction as isProduction} from './Environment';

const missingKeyHandler: InitOptions['missingKeyHandler'] = (
  _lng,
  _ns,
  key,
  _fallbackValue,
  _updateMissing,
  options
) => {
  const hasDefaultValue = !!options && 'defaultValue' in options;

  if (!hasDefaultValue) {
    throw new Error(`Missing translation: ${key}`);
  }
};

export const defaultNS = 'translation' as const;

export const resources = {
  en: {
    translation: en,
  },
} as const;

i18n.init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  resources: {
    en: {
      translation: en,
    },
  },
  missingKeyHandler,
  saveMissing: !isProduction,
  interpolation: {
    escapeValue: false,
    format: i18nFormat,
  },
  supportedLngs: ['en'],
});

export type I18n = typeof i18n;

export default i18n;
